














































































































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { DetailItem } from "@/store/custom/statistic/types";
import {LongTextWings, ScrollButton} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import CustomDetailFilter from "@/components/Custom/CustomDetailFilter.vue";
import { dateFilter } from "@/utils/date-util";

@Component({ components: {CustomDetailFilter, ScrollButton, LongTextWings}, filters: {dateFilter} })
export default class CustomDetail extends BaseItemsPage<DetailItem> {

  @Getter("customStatisticDetail") responseItems: any;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "create_date",
      "originator",
      "recipient",
      "message",
      "status",
      "partner_price",
      "detail"
    ];
  }

  getData() {
    return this.responseItems;
  }

}
